export enum FractionTsUnitEnum {
  Seconds = 'seconds',
  Minutes = 'minutes',
  Hours = 'hours',
  Days = 'days',
  Weeks = 'weeks',
  Months = 'months',
  Quarters = 'quarters',
  Years = 'years'
}
